function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.8153 0.470706C20.3108 0.179432 19.6892 0.179432 19.1847 0.470706L3.49478 9.52929C2.99028 9.82057 2.67949 10.3589 2.67949 10.9414V29.0586C2.67949 29.6411 2.99028 30.1794 3.49478 30.4707L19.1847 39.5293C19.6892 39.8206 20.3108 39.8206 20.8153 39.5293L36.5052 30.4707C37.0097 30.1794 37.3205 29.6411 37.3205 29.0586V10.9414C37.3205 10.3589 37.0097 9.82057 36.5052 9.52929L20.8153 0.470706Z",
  fill: "#002A95"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4967 23.2794C20.1892 23.1025 19.8108 23.1025 19.5033 23.2794L13.4297 26.7737C12.8971 27.0801 12.8971 27.8486 13.4297 28.155L19.5033 31.6493C19.8108 31.8262 20.1892 31.8262 20.4967 31.6493L26.5702 28.155C27.1028 27.8486 27.1028 27.0801 26.5702 26.7737L20.4967 23.2794Z",
  fill: "#003FE0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4964 17.1643C20.189 16.9876 19.811 16.9876 19.5037 17.1643L11.2655 21.8996C10.7325 22.206 10.7325 22.9749 11.2655 23.2813L19.5037 28.0166C19.811 28.1933 20.189 28.1933 20.4964 28.0166L28.7345 23.2813C29.2675 22.9749 29.2675 22.206 28.7345 21.8996L20.4964 17.1643Z",
  fill: "#0070F3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.498 10.4787C20.1899 10.3007 19.8101 10.3007 19.5019 10.4787L8.71092 16.7097C8.17977 17.0164 8.17977 17.783 8.71092 18.0897L19.5019 24.3207C19.8101 24.4987 20.1899 24.4987 20.498 24.3207L31.2891 18.0897C31.8202 17.783 31.8202 17.0164 31.2891 16.7097L20.498 10.4787Z",
  fill: "#00AAF3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4978 3.79047C20.1898 3.61268 19.8103 3.61268 19.5022 3.79046L6.10034 11.5245C5.56896 11.8312 5.56896 12.5981 6.10034 12.9048L19.5022 20.6388C19.8103 20.8166 20.1898 20.8166 20.4978 20.6388L33.8997 12.9048C34.4311 12.5981 34.4311 11.8312 33.8997 11.5245L20.4978 3.79047Z",
  fill: "white"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.dd8aec1a.svg";
export { ForwardRef as ReactComponent };